import { Badge, type Column, type ITableWithStoredSettingsProps } from '@synqo/frontend-component-library';
import {
    ApiOrder,
    EnumMaterialFlow,
    EnumProcessState,
    getBadgeVariantByProcessState,
    getEnumMaterialFlowLabel,
    getEnumProcessStateLabel,
    materialFlowOptions,
    processStateOptions,
} from '@Model';

export const initialOrderSorting: Readonly<ITableWithStoredSettingsProps<ApiOrder>['initialSorting']> = {
    columnName: 'created_at',
    direction: 'desc',
};

export const orderColumns: Readonly<Column<ApiOrder>>[] = [
    { name: 'number', label: 'Nummer' },
    {
        name: 'material_flow',
        label: 'Stoffweg',
        filterVariant: 'select',
        filterOptions: materialFlowOptions,
        renderCell: ({ cellData }) => getEnumMaterialFlowLabel(cellData as EnumMaterialFlow),
    },
    { name: 'customer.display_string', label: 'Kunde' },
    {
        name: 'site.display_string',
        label: 'Lieferanschrift',
        renderCell: ({ rowData }) => rowData.site?.address?.display_string,
    },
    { name: 'completed_at', label: 'Erledigt am', type: 'datetime' },
    {
        name: 'created_at',
        label: 'Eingang',
        type: 'date',
    },
    {
        name: 'process_state',
        label: 'Status',
        filterVariant: 'select',
        filterOptions: processStateOptions,
        renderCell: ({ cellData }) => (
            <Badge variant={getBadgeVariantByProcessState(cellData as EnumProcessState)}>
                {getEnumProcessStateLabel(cellData as EnumProcessState)}
            </Badge>
        ),
    },
    { name: 'vehicle.display_string', label: 'Fahrzeug' },
    { name: 'planned_start', label: 'Plandatum', type: 'datetime' },
];
